/**
 * Export component file to be used on project
 */

import ConnectionError from './ConnectionError';
export default ConnectionError;
